<template>
  <div>
    <Portal to="lefSideBar">
      <div class="login-form-wrapper">
        <div class="content text-center">
          <div class="logo">
            <img alt class="login-logo" src="@/assets/images/login-logo.png" />
            <img alt class="login-logo-text" src="@/assets/images/login-logo-text.png" />
          </div>

          <div class="google-login-area">
            <div class="google-login-link" v-google-signin-button="clientId" id="signin_button"></div>
          </div>
          <div class="text-danger">
            {{ errorMsg }}
          </div>

          <div class="footer">©︎ 2020 Tamai Investment Educations Inc.</div>
        </div>
      </div>
    </Portal>
  </div>
</template>

<script>
import { Portal } from 'portal-vue';
import { loggedIn, isLoginPath } from '@/helpers/Authentication.js';
import GoogleSignIn from '@/directives/google_signin';

export default {
  directives: {
    GoogleSignIn,
  },
  data() {
    return {
      clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID,
      errorMsg: '',
    };
  },
  components: {
    Portal,
  },
  computed: {
    ...loggedIn,
  },
  created() {
    if (this.loggedIn && isLoginPath(this.$route.fullPath)) {
      this.$router.push({ name: 'home' });
    }
  },
  methods: {
    onGoogleAuthSuccess(googleUser) {
      const vueInstance = this;
      const token = googleUser.credential;
      const email = this.parseJwt(token).email;

      window.google.accounts.id.revoke(email);

      if (!/@tamaishiki\.com$/.test(email)) {
        let msgError = email + ' is invalid. This client is restricted to users within its organization.';
        vueInstance.$logger.debug('[GoogleAuth] Error', msgError);
        vueInstance.errorMsg = 'Googleログイン（TIE）に失敗しました。もう一度お試しください！';
        return;
      }
      vueInstance.$store
        .dispatch('auth/googleAuth', { token })
        .then(() => {
          vueInstance.$router.push({ name: 'home' }).catch((error) => {
            if (error.name != 'NavigationDuplicated') {
              throw error;
            }
          });
        })
        .catch((error) => {
          vueInstance.$logger.debug('[GoogleAuth] Error', error.response.data.error);
          vueInstance.errorMsg = error.response.data.error;
        });
    },
    parseJwt(token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );

      return JSON.parse(jsonPayload);
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  .content {
    width: 100%;
    margin-top: 50%;
    .logo {
      text-align: center;
      display: block;
      margin-bottom: 70px;
      img {
        text-align: center;
        display: block;
        margin: auto;
        &.login-logo {
          margin-bottom: 15px;
        }
      }
    }
  }

  .google-login-area {
    display: flex;
    justify-content: center;
  }
  .google-login-link {
    margin-bottom: 20px;
    text-decoration: none;
    cursor: pointer;
  }
  .text-danger {
    padding: 20px;
  }

  .footer {
    color: #7e7964;
    font-size: 8px;
    position: absolute;
    bottom: 0px;
    width: 100%;
  }

  form.loginForm {
    padding: 30px;
    text-align: left;
    img {
      margin-bottom: 10px;
    }
    .login-hint-label {
      height: 50px;
    }
    label {
      font-weight: bold;
    }
    input {
      border-radius: 12px;
    }
    .btn-login {
      margin-top: 10px;
      background-color: transparent;
      color: #28a745;
      padding: 4px 20px;
      border-radius: 4px;
    }
    .form-group {
      .form-login-icon {
        position: absolute;
        width: auto;
        bottom: 3px;
        right: 5px;
        margin-top: 0;
        font-size: 90%;
        color: #6c757dab;
      }
    }
  }
}
</style>
